








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { MortgageTypeDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxMortgageType extends Vue {
  private types: MortgageTypeDto[] | null = [];
  public selectedType = new MortgageTypeDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: MortgageTypeDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: MortgageTypeDto) {
    this.$emit("mortgageTypeSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .mortgageType_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
